import React, { memo, useState } from 'react';
import { useRouter } from 'next/router';
import { Button, Popover, DropdownBox } from '@tencent/tea-component';
import { openPcLobbyPage } from 'src/utils/concat-meeting-util';
import dataReport from '@utils/data-report';
import classnames from 'classnames';
import './index.scss';

interface Props {
  isPreview?: boolean;
  gotoPreview?: Function;
  className?: string;
  previewRef?: any;
  lookText?: string;
}
const PreviewBtn = (props: Props) => {
  const { isPreview, gotoPreview, className, previewRef, lookText = '查看活动' } = props;
  const router = useRouter();
  const { query } = router;
  const eventId = String(query.eventid);
  const text = isPreview ? '查看' : '预览';
  const btnText = isPreview ? lookText : '预览';
  const [popoverVisible, setPopoverVisible] = useState(false);
  return (
    <Popover
      overlayClassName="select-bubble"
      placement="bottom"
      placementOffset={6}
      onVisibleChange={(val: boolean) => setPopoverVisible(val)}
      overlay={
        <DropdownBox ref={previewRef}>
          <div
            className="preview-item"
            onClick={() => {
              dataReport('e#event_navigation#preview_registrationpage_button#click');
              gotoPreview?.();
            }}
          >
            {text}活动详情
          </div>
          <div
            className="preview-item"
            onClick={() => {
              if (isPreview) {
                openPcLobbyPage(eventId);
                return;
              }
              openPcLobbyPage(eventId, '?isPreview=1');
            }}
          >
            {text}活动大厅
          </div>
        </DropdownBox>
      }
    >
      <Button type={isPreview ? 'primary' : 'weak'} className={`preview-btn ${className}`}>
        <span>{btnText}</span>
        <i className={classnames('iconfont icon-arrow-down drop-down', popoverVisible && 'up')}></i>
      </Button>
    </Popover>
  );
};
export default memo(PreviewBtn);
